import { useReadQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { gql } from '@/__generated__';
import { preloadQuery } from '@/apollo/apollo-client.ts';
import { deleteSearchParams } from '@/utils/handle-search-param.ts';
import { getXAuthLink } from '../../utils/get-x-auth-link';

const meUsernameQuery = gql(`
  query meUsernameQuery {
    me {
      username
    }
}
`);

export const useConnectToX = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const xcomParam = params.get('xcom');
  const {
    data: { me },
  } = useReadQuery(preloadQuery(meUsernameQuery));

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('xcom'))
      setSearchParams(deleteSearchParams(searchParams, ['xcom']));
  }, [searchParams, setSearchParams]);

  return {
    isAfterConnect: xcomParam === 'true',
    authLink: getXAuthLink(me?.username ?? ''),
  };
};
